import './css/loaderSmall.css'

function LoaderSmall() {
  return (
    <span class="loaderSmall"></span>
  )
}

export default LoaderSmall